import React from "react";
import { FieldValues, useForm } from "react-hook-form";
import NotificationCard from "../notificationCard/NotificationCard";
import Notification from "../../../../interfaces/Notification";
import { OutlinedButton } from "../../../../../../shared/native/button.styles";
import AddFileButton from "../../../../../../shared/addFileButton/AddFileButton";
import colors from "../../../../../../../core/styles/colors";
import { useAppDispatch } from "../../../../../../../core/hooks/redux";
import { submitNotificationRequest } from "../../../../../../../http/requests/notifications.http";
import { removeNotification } from "../../../../../../../store/modules/notifications/notificationsSlice";
import AddFileInfo from "../../../../../../shared/addFileInfo/AddFileInfo";
import { PAYMENT_RECEIPT_DOCUMENT_ID } from "../../../../constants/paymentDocumentConstants";
import {
  getPaymentPayloadForRequest,
  isPaymentPayloadNotEmpty,
} from "../../../../utils/paymentPayload";
import { requestOnlinePaymentUrl } from "../../../../../../../http/requests/payment.http";
import openUrlInNewTab from "../../../../utils/openUrlInNewTab";
import { ActionsRow, FilesActionsGroup, OnlinePaymentButton } from "./previewAndUploadType.styles";

const PreviewAndUploadType: React.FC<{ notification: Notification }> = ({ notification }) => {
  const dispatch = useAppDispatch();
  const [disableResponseButton, setDisableResponseButton] = React.useState(false);
  const [isOnlinePaymentLoading, setIsOnlinePaymentLoading] = React.useState(false);
  const showOnlinePaymentButton =
    notification.document_id === PAYMENT_RECEIPT_DOCUMENT_ID &&
    isPaymentPayloadNotEmpty(notification.payment_payload);
  const { control, setValue, handleSubmit } = useForm<FieldValues>({
    defaultValues: {
      files: [],
    },
  });

  const submitHandler = (data: FieldValues): void => {
    setDisableResponseButton(true);
    submitNotificationRequest({
      notify_id: notification.uid,
      type: notification.notification_type,
      files: data.files,
      answer: "",
    }).then((res) => {
      setDisableResponseButton(false);
      if (res.data.error) {
        return;
      }

      dispatch(removeNotification(notification.uid));
    });
  };

  const openLinkHandler = (): void => {
    window.open(notification.file_url, "_blank").focus();
  };

  const onlinePaymentHandler = async (): Promise<void> => {
    if (!notification.payment_payload) {
      return;
    }

    setIsOnlinePaymentLoading(true);

    try {
      const paymentUrl = await requestOnlinePaymentUrl(
        getPaymentPayloadForRequest(notification.payment_payload)
      );

      if (paymentUrl) {
        openUrlInNewTab(paymentUrl);
      }
    } finally {
      setIsOnlinePaymentLoading(false);
    }
  };

  return (
    <NotificationCard
      title={notification?.document_name}
      comment={notification.comment}
      handleSubmit={handleSubmit(submitHandler)}
      disableResponseButton={disableResponseButton}
    >
      <ActionsRow>
        <FilesActionsGroup>
          <OutlinedButton
            type="button"
            onClick={openLinkHandler}
            initialBackground={colors.white.general}
          >
            Открыть
          </OutlinedButton>
          <AddFileButton
            control={control}
            setValue={setValue}
            multiple
            name="files"
            options={{ required: "Обязательное поле" }}
            accept="image/*"
            previewProps={{
              whiteBackground: true,
              style: { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 },
            }}
            buttonProps={{
              whiteBackground: true,
            }}
          >
            Загрузить
          </AddFileButton>
        </FilesActionsGroup>
        {showOnlinePaymentButton && (
          <OnlinePaymentButton
            type="button"
            onClick={onlinePaymentHandler}
            disabled={isOnlinePaymentLoading}
            initialBackground={colors.white.general}
          >
            Оплатить онлайн
          </OnlinePaymentButton>
        )}
      </ActionsRow>
      <AddFileInfo style={{ marginTop: "16px" }} />
    </NotificationCard>
  );
};

export default PreviewAndUploadType;
